import React, { useContext } from "react";
import { Container, Grid, Box } from "@mui/material";
import CcpSchoolBreadCrumbs from "../../Layout/CcpSchoolBreadCrumbs";
import { SchoolContext } from "../../../config/SchoolContext";
import HeadCount from "./inc/HeadCount";
import CreditHours from "./inc/CreditHours";
import Top10Courses from "./inc/Top10Courses";
import Gender from "./inc/Gender";
import GradeLevel from "./inc/GradeLevel";
import CourseModality from "./inc/CourseModality";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";

const CcpStatsAndTrends = () => {
  const { schoolId } = useContext(SchoolContext);
  const pageName = "Stats and Trends";
  const icon = faChartBar;

  return (
    <Container sx={{ marginTop: "100px" }}>
      <Box sx={{ flexGrow: 1 }}>
        <CcpSchoolBreadCrumbs pageName={pageName} icon={icon} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h4>Stats and Trends</h4>
          </Grid>
          <Grid item xs={6}>
            <HeadCount schoolId={schoolId} />
          </Grid>
          <Grid item xs={6}>
            <CreditHours schoolId={schoolId} />
          </Grid>
          <Grid item xs={12}>
            <Top10Courses schoolId={schoolId} />
          </Grid>
          <Grid item xs={12}>
            <Gender schoolId={schoolId} />
          </Grid>
          <Grid item xs={12}>
            <GradeLevel schoolId={schoolId} />
          </Grid>
          <Grid item xs={12}>
            <CourseModality schoolId={schoolId} />
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpStatsAndTrends;
